import {
  EventDateRangeModeEnum,
  EventTypeEnum,
} from 'modules/calendar/events/enums/event-type-enum'
import { EventCreateFormInterface } from '../types/event-interface'

export enum EventTimeZoneTypeEnum {
  Fixed = 'FIXED',
  Local = 'LOCAL',
}

export enum EventLocationTypeEnum {
  ExternalLink = 'ONLINE_MEETING',
  Phone = 'PHONE',
  Personal = 'PERSONAL',
  Zoom = 'ZOOM',
  GoogleMeet = 'GOOGLE_MEET',
}

export const defaultValues: EventCreateFormInterface = {
  locations: [],
  name: '',
  startTimeIncrement: 30,
  bookingBufferTime: null,
  displayTimezone: '',
  displayTimezoneType: EventTimeZoneTypeEnum.Local,
  endDate: '',
  eventDuration: 30,
  farOutBookRange: 0,
  maxBookingsPerDay: null,
  nearestBookRange: null,
  cancellationDeadline: null,
  ownerId: null,
  startDate: '',
  useGlobalAvailability: true,
  bookingThreshold: null,
  description: '',
  hostName: '',
  hostAvatarUrl: '',
  customLogo: null,
  eventType: EventTypeEnum.Individual,
  maxParticipants: null,
  dateRangeMode: EventDateRangeModeEnum.Range,
}

export const locationFields: Record<EventLocationTypeEnum, Record<string, string>> = {
  [EventLocationTypeEnum.ExternalLink]: {
    meetingLink: '',
  },
  [EventLocationTypeEnum.Zoom]: {
    meetingLink: '',
  },
  [EventLocationTypeEnum.GoogleMeet]: {
    meetingLink: '',
  },
  [EventLocationTypeEnum.Personal]: {
    address: '',
    phone: '',
  },
  [EventLocationTypeEnum.Phone]: {
    phone: '',
  },
}

export const linkTypes = [
  {
    id: EventLocationTypeEnum.Zoom,
    caption: 'dashboard.calendar.event_location_type_zoom',
  },
  {
    id: EventLocationTypeEnum.GoogleMeet,
    caption: 'dashboard.calendar.event_location.google_meet',
  },
  {
    id: EventLocationTypeEnum.ExternalLink,
    caption: 'dashboard.calendar.event_location_type_external_link',
  },
]
